module.exports = __webpack_public_path__ + "img/paypal.c7d13c66.svg";